import { alpha } from '@mui/material/styles'
import { Plugin } from 'chart.js'

export const pointLabels = (color: string): Plugin<'line'> => ({
  id: 'supplierActivationPointLabels',
  afterDatasetsDraw: (chart) => {
    const meta = chart.getDatasetMeta(0)
    const values = chart.data.datasets[0]?.data as (number | null)[] | undefined

    if (!values) return

    const { ctx } = chart

    ctx.save()
    ctx.font = '600 11px Roboto, sans-serif'
    ctx.fillStyle = color
    ctx.textAlign = 'center'
    ctx.textBaseline = 'bottom'

    meta.data.forEach((point, index) => {
      const value = values[index]

      if (value == null) return

      ctx.fillText(`${Math.round(value)}%`, point.x, point.y - 8)
    })

    ctx.restore()
  },
})

export const activePointGuide = (color: string): Plugin<'line'> => ({
  id: 'supplierActivationActivePointGuide',
  afterDatasetsDraw: (chart) => {
    const active = chart.tooltip?.getActiveElements() ?? []

    if (active.length === 0) return

    const { x, y } = active[0].element
    const { ctx, chartArea } = chart

    ctx.save()

    ctx.setLineDash([4, 4])
    ctx.lineWidth = 1
    ctx.strokeStyle = alpha(color, 0.6)
    ctx.beginPath()
    ctx.moveTo(x, y)
    ctx.lineTo(x, chartArea.bottom)
    ctx.stroke()

    ctx.setLineDash([])
    ctx.lineWidth = 1.5
    ctx.strokeStyle = color
    ctx.beginPath()
    ctx.arc(x, y, 6, 0, Math.PI * 2)
    ctx.stroke()

    ctx.restore()
  },
})
